import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorks } from './components/HowItWorks';
import { WhatsIncluded } from './components/WhatsIncluded';
import { CardPreview } from './components/CardPreview';
import { Bonuses } from './components/Bonuses';
import { UseMoments } from './components/UseMoments';
import { OfferStack } from './components/OfferStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-night font-sans text-parchment" data-id="element-0" data-mp="23vcm2yxfpmes">
      <noscript data-id="element-1" data-mp="23v2rsz5cwt3a">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="23ti864kkyuk7" />
      </noscript>
      <Hero data-id="element-3" data-mp="3rcj846sey78q" />
      <main data-id="element-4" data-mp="3rbzmaezn6ypf">
        <PainPoints data-id="element-5" data-mp="3rdarmj8qkein" />
        <SolutionSection data-id="element-6" data-mp="3rd1bdndhtlq5" />
        <HowItWorks data-id="element-7" data-mp="3relwynhtxubv" />
        <WhatsIncluded data-id="element-8" data-mp="6hqffdy0fe4" />
        <CardPreview data-id="element-9" data-mp="4ww9qvjiygs" />
        <Bonuses data-id="element-10" data-mp="56ntiw8hdol" />
        <UseMoments data-id="element-11" data-mp="7sulgbavp5r" />
        <OfferStack data-id="element-12" data-mp="2zld2xbxu5jcl" />
        <Guarantee data-id="element-13" data-mp="2zlv8iz6e19x6" />
        <Faq data-id="element-14" data-mp="2zmem63p09c5e" />
        <FinalCta data-id="element-15" data-mp="2zmwggus3xgao" />
      </main>
      <Footer data-id="element-16" data-mp="33morde4z3yj7" />
      <StickyCta data-id="element-17" data-mp="33m5ck6amdq9e" />
    </div>;
}